import React from "react";
import { 
    AlertCircle,
    CircleCheck,
    Clock,
    Handshake,
    Plus,
 } from "lucide-react";
import SummaryHeader from "components/header/SummaryHeader";
import SummaryItem from "components/header/SummaryItem";
import SupportTicket from "./components/SupportTicket";
import SupportTabs from "./components/SupportTabs";
import PopupButton from "components/button/PopupButton";
import { MODULE_SUPP_TICKETS } from "variables/constants";

const PartnerService = () => {
    return (
        <div className="grid grid-cols-1">
            <div className="space-y-6 max-w-[1800px]">
                <SummaryHeader
                    title={"Partner Service"}
                    icon={Handshake}
                    description={"Billing, contracts, and partnership support"}
                    color={"bg-purple"}
                    rightNav={
                        <PopupButton 
                            id="add_ticket" 
                            title="Submit Partner Service Ticket"
                            description="Get assistance with billing, contracts, and partnership inquiries"
                            label="New Ticket" 
                            btnClass="ticket btn-ticket purple" 
                            action="add"
                            moduleId={0}
                            icon={Plus}
                            useCustomClass={true}
                            modalWidth={500}
                        >
                            <SupportTicket recordId="0" mode="edit"/>
                        </PopupButton>
                    }
                >
                   <div className="summary-item-container">
                        <SummaryItem
                            title="Open Tickets"
                            icon={<AlertCircle />}
                            display="2"
                        />
                        <SummaryItem
                            title="In Progress"
                            icon={<Clock />}
                            display="2" 
                        />
                        <SummaryItem
                            title="Resolved"
                            icon={<CircleCheck />}
                            display="1" 
                        />
                   </div>
                </SummaryHeader>
                <SupportTabs />
            </div>
        </div>
    )
};
export default PartnerService;